import { ecsApi } from '@services';
import { GetProductCategoriesResponse, GetProductsByCategoryResponse } from './products.types';

export const productsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductCategories: builder.mutation<GetProductCategoriesResponse, void>({
            query: () => ({
                url: '/products/categories',
                method: 'GET'
            })
        }),
        getProductsByCategory: builder.mutation<GetProductsByCategoryResponse, string>({
            query: (categoryId) => ({
                url: `/products?id_category=${categoryId}`,
                method: 'GET'
            })
        })
    })
});

export const { useGetProductCategoriesMutation, useGetProductsByCategoryMutation } = productsApi;
